export const LOWER = 'lower';
export const MIDDLE = 'middle';
export const NONE = 'none';
export const UPPER = 'upper';